export default "__VITE_ASSET__66356936__";